module.exports = __webpack_public_path__ + "img/3.1275b7de.webp";